import { Component, computed, Inject, Input, OnDestroy, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { CartStateService, MixedPaymentsErrorPopupComponent, PaymentsService } from '@equine-ui-nx/payments';
import { takeUntil, switchMap, tap, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { TeamBulkPaymentConfirmationDialogComponent } from 'libs/iea/protocols/asset/src/lib/teams/ui/team-bulk-payment-confirmation-dialog/team-bulk-payment-confirmation-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Order } from 'libs/payments/src/lib/payments/payment/interfaces/payment-summary.interface';


@Component({
  selector: 'eq-cnf-dialog-show',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatTableModule
  ],
  templateUrl: './popup-message-tabular.component.html',
  styleUrl: './popup-message-tabular.component.scss',
})
export class PopupMessageTabularShowComponent implements OnInit, OnDestroy {
  mainHeader!: string[];
  header!: string[];
  rows!: string[][];
  displayedColumns!: string[];
  unsubscribe$ = new Subject<void>();
  userId!: string;
  whoPay!: string;
  addedToCartIds = signal<string[]>([]);
  orders = signal<Order[]>([]);
  references = computed(() => this.orders().map(each => each.reference));

  constructor(
    public dialogRef: MatDialogRef<PopupMessageTabularShowComponent>,
    private readonly dialog: MatDialog,
    private paymentsService: PaymentsService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    private cartState: CartStateService
  ) {}

  ngOnInit(): void {
    this.mainHeader = this.data?.mainHeader;
    this.header = this.data?.header;
    this.userId = this.data?.userId;
    let count = 0;
    this.whoPay = this.data?.whoPay;
    this.rows = this.data?.rows.map((row: any)=> {
      row.slno = ++count;
      row.class = row?.classDet?.description;
      row.price = row?.productAmount;
      return row;
    });
    this.displayedColumns = ['slno', 'class', 'price', 'status'];// Object.keys(this.data?.rows[0]);

    this.orders = this.cartState.orders;
  }

  isPaymentEnable(entryDetails: any): boolean {
    const isPaymentEnable = [ 'generated_program', 'awaiting_result'].includes(entryDetails?.showStatus) && ['approved'].includes(entryDetails?.status);

    return isPaymentEnable && entryDetails?.usedOnlineEntryPaymentService !== false;
  }

  payRiderFees(entryDetails: any) {
    this.snackBar.open('Please pay on dashboard.', 'Dismiss', {
      duration: 3000,
      panelClass: ['error-snackbar'],
    });
    throw new Error('Please pay on dashboard');

    if (!(!entryDetails.isShowEntryFee && entryDetails.paymentStatus == 'pending_payment')) {
      this.snackBar.open('Something went wrong.', 'Dismiss', {
        duration: 3000,
        panelClass: ['error-snackbar'],
      });
      return;
    }

    if (!this.isPaymentEnable(entryDetails)) {
      this.snackBar.open('Payment not enable for this show. Please contact IEA for any kind of help.', 'Dismiss', {
        duration: 3000,
        panelClass: ['error-snackbar'],
      });
      return
    }

    if(entryDetails?.usedOnlineEntryPaymentService === false) {
      this.snackBar.open('Payment mode is offline for this show. Please contact IEA for any kind of help.', 'Dismiss', {
        duration: 3000,
        panelClass: ['error-snackbar'],
      });
      return
    }

    this.paymentsService.createOrderWithProducts(
      entryDetails.entryId,
      [{ productId: entryDetails.productId, quantity: 1 }],
      'RIDER_ENTRY_CAPTURE',
      'main',
      "CAPTURE"
    )
      .pipe(
        takeUntil(this.unsubscribe$),
        switchMap((orders) => this.paymentsService.addToCart(this.userId, [orders.id], this.userId)),
        tap(() => this.paymentsService.getCartSummary(undefined, this.userId).subscribe()),
      )
      .subscribe({
        next: (response) => {
          this.addedToCartIds.set([...this.addedToCartIds(), entryDetails.entryId])
        },
        error: (error) => {
          if (this.paymentsService.requiresOpenPopup(error)) {
            this.dialog.open(MixedPaymentsErrorPopupComponent, {
              data: {
                reference: this.userId
              }
            })
          } else {
            this.snackBar.open(error?.error?.message || 'A problem occured creating order', "Dismiss", { duration: 5000, panelClass: ['error-snackbar'] });
          }
        }
      })
  }

  goToCart() {
    this.dialog.closeAll();
    setTimeout(() => {
      this.router.navigate(['payments', 'payment-summary']);
    }, 100);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
